// extracted by mini-css-extract-plugin
module.exports = {"wrap":"kc","title":"lc"};